/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  Button, ButtonSize, Highlights, Image, Badge, BadgeColor, Link, Grid, SpacingName,
} from '@doveit/lego';
import * as styles from './PropertyCard2.style';
import { URLObject } from '../../utils/links';

export interface PropertyCard2Props {
  title: string,
  suburb?: string,
  price: string,
  onClick?: VoidFunction,
  urlObject?: URLObject,
  features?: string[],
  cover: string,
  gallery?: string[],
  banner?: string,
  newBuilding?: boolean,
  description?: string,
  label?: string,
  ariaLabel?: string,
  promoted?: boolean,
}

export const PropertyCard2: React.FC<PropertyCard2Props> = ({
  title,
  suburb,
  price,
  onClick,
  urlObject,
  cover,
  gallery,
  banner,
  newBuilding,
  description,
  promoted,
  features = [],
  ariaLabel = 'Clicca per vedere i dettagli immobile',
  label = 'Vedi immobile',
}) => {
  const badges = React.useMemo(
    () => [
      promoted && 'Premium',
      newBuilding && 'Nuova costruzione',
    ].filter((i) => i),
    [newBuilding, promoted],
  );

  return (
    <article
      css={styles.basic}
      $interactive={!!onClick}
    >
      {onClick && (
        <div
          css={styles.overlayLink}
          onClick={onClick}
          title={ariaLabel}
          aria-label="property-card-overlay"
          role="button"
        />
      )}
      <div css={styles.content}>
        <div css={styles.info}>
          <h2 css={styles.title}>
            <Link
              aria-label="anchor-link"
              href={urlObject?.as}
            >
              {title}
            </Link>
          </h2>
          {suburb && (
            <div css={styles.suburb}>{suburb}</div>
          )}
          {features && (
            <div css={styles.highlights}>
              <Highlights items={features} />
            </div>
          )}
          <div css={styles.price}>
            {price}
          </div>
          {description && (
            <p css={styles.description}>
              {description}
            </p>
          )}
          {onClick && (
            <div css={styles.actions}>
              <Button
                label={label}
                size={ButtonSize.SMALL}
                onClick={onClick}
                aria-label={ariaLabel}
              />
            </div>
          )}
        </div>
        <div css={styles.preview}>
          <div css={styles.cover}>
            {badges.length > 0 && (
              <div
                css={styles.badges}
                aria-label="badges"
              >
                {badges.map((badge, i) => (
                  <Badge
                    key={badge}
                    text={badge}
                    color={i === 0 ? BadgeColor.PRIMARY : BadgeColor.NEUTRAL}
                  />
                ))}
              </div>
            )}
            {banner && (
              <div
                css={styles.banner}
                aria-label="property-card-banner"
              >
                {banner}
              </div>
            )}
            <Image
              src={cover}
              alt={`Anteprima ${title}`}
              loading="lazy"
              responsive
            />
          </div>
          {gallery && gallery.length > 0 && (
            <div css={styles.gallery}>
              <Grid gutter={SpacingName.SMALLEST}>
                {gallery.slice(0, 2).map((image, i) => (
                  <Grid.Unit
                    key={image}
                    size={1 / 2}
                  >
                    <Image
                      src={image}
                      alt={`Foto gallery ${i + 1} di ${title}`}
                      loading="lazy"
                      responsive
                    />
                  </Grid.Unit>
                ))}
              </Grid>
            </div>
          )}
          {onClick && (
            <div css={styles.mobileActions}>
              <Button
                label={label}
                size={ButtonSize.SMALL}
                expanded
                onClick={onClick}
                aria-label={ariaLabel}
              />
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default PropertyCard2;
